import Image from 'next/image'
import styles from '@/components/Header/Header.module.scss'
import useTotalNewMessages from '@hooks/header/account/useTotalNewMessages'
import classNames from 'classnames'

// import Cookies from 'js-cookie'

type HeaderAccountMenuProps = {
  user: OnliveUser
  hasDarkMode?: boolean
}

const HeaderAccountMenu = ({user, hasDarkMode}: HeaderAccountMenuProps) => {
  const {totalNewMessages} = useTotalNewMessages()

  // const switchPlay = () => {
  //   Cookies.set('theme', '', {
  //     domain: '.onlive.vn',
  //     expires: 1 / 25,
  //     sameSite: 'Lax',
  //     secure: true,
  //   })
  //   window.location.reload()
  // }

  return (
    <div
      className={classNames([styles.menuBgShadow, styles.menuAccountWrapper])}
    >
      <div className={styles.menuCommonCol}>
        <ul>
          <li>
            <a href={`https://streamer.onlive.vn/${user?.uid}`}>
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/home.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Blog</span>
            </a>
          </li>
          <li>
            <a href="https://my.onlive.vn/favorite">
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/star.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Yêu thích</span>
            </a>
          </li>
          <li>
            <a href="https://point.onlive.vn/mygift-quickview/">
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/shopping-bag.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Vật phẩm của tôi</span>
            </a>
          </li>
          <li>
            <a href="https://point.onlive.vn/mygift-starballoon/">
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/Balloon.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Bóng bay của tôi</span>
            </a>
          </li>
          <li>
            <a href="https://point.onlive.vn/mygift-subscription/">
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/cup.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Đăng ký của tôi</span>
            </a>
          </li>
          <li>
            <a
              href="https://note.onlive.vn/app/index.php"
              className={styles.myMail}
            >
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/sms.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Thư của tôi</span>
              <span className={styles.mailCounter}>{totalNewMessages}</span>
              {totalNewMessages > 0 && (
                <Image
                  src={
                    process.env.NEXT_PUBLIC_PATH_DOMAIN +
                    'images/header/icon-new.svg'
                  }
                  width={12}
                  height={12}
                  alt=""
                />
              )}
            </a>
          </li>
          <li>
            <a href="https://dashboard.onlive.vn/index.php">
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/setting-2.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Cài đặt phát sóng thiết bị bên ngoài</span>
            </a>
          </li>
          <li>
            <a href="https://member.onlive.vn/app/user_info.php?szWork=INFO_MODIFY_FORM">
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/info-circle.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Thông tin tài khoản</span>
            </a>
          </li>
          <li>
            <a href="https://broadstatistic.onlive.vn/">
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/chart.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Thống kê của tôi</span>
            </a>
          </li>
          {/* <li className={styles.newPlay}>
            <button onClick={switchPlay}>
              <Image src={process.env.NEXT_PUBLIC_PATH_DOMAIN + 'images/icons/header/switch.svg'} alt="" width={20} height={20}/>
              <span>Giao diện cũ</span>
            </button>
          </li>
          {hasDarkMode && (
            <li>
              <a href="https://broadstatistic.onlive.vn/">
                <Image src={process.env.NEXT_PUBLIC_PATH_DOMAIN + 'images/icons/header/dark-mode.svg'} alt="" width={20} height={20}/>
                <span>Chế độ tối</span>
              </a>
            </li>
          )} */}
          <li>
            <a
              href={`${process.env.NEXT_PUBLIC_LOGIN_DOMAIN}/app/LogOut.php?request_uri=${window.location.href}`}
            >
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/header/undo.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              <span>Đăng xuất</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default HeaderAccountMenu
